import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '#components/Button'
import { useAuth } from '#hooks/useAuth'

import styles from './styles.module.scss'

export const ImpersonationBanner = (): React.JSX.Element | null => {
  const { t } = useTranslation()
  const { user, isImpersonating, stopImpersonation } = useAuth()

  if (!isImpersonating || !user) return null

  return (
    <div className={styles.banner} role="alert" data-testid="impersonation-banner">
      <span className={styles.text}>
        {t('You are impersonating {{ name }}', { name: user.displayName ?? user.email })}
      </span>
      <Button
        variant="danger"
        size="sm"
        onPress={(): void => void stopImpersonation()}
        data-testid="stop-impersonation"
      >
        {t('Stop impersonation')}
      </Button>
    </div>
  )
}
